import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdd220fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = {
  for: "hospital_name",
  class: "form-label fw-bold"
}
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = {
  for: "hospital_location",
  class: "form-label fw-bold"
}
const _hoisted_5 = { class: "mb-8" }
const _hoisted_6 = {
  for: "physician_name",
  class: "form-label fw-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    class: "medical-records-form-wrapper w-100 w-md-50 mb-15",
    onSubmit: $setup.onSubmit,
    "validation-schema": $setup.validationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("Hospital Name")), 1),
        _createVNode(_component_Field, {
          class: "form-control fw-normal",
          name: "hospital_name",
          placeholder: "Enter your hospital name",
          modelValue: $setup.hospitalName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.hospitalName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "hospital_name",
          class: "invalid-input-alert mx-1 mt-1"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("City, State")), 1),
        _createVNode(_component_Field, {
          class: "form-control fw-normal",
          name: "hospital_location",
          placeholder: "Enter hospital city",
          modelValue: $setup.cityState,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.cityState) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "hospital_location",
          class: "invalid-input-alert mx-1 mt-1"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("Physician Name")), 1),
        _createVNode(_component_Field, {
          class: "form-control fw-normal",
          name: "physician_name",
          placeholder: "Enter your physician name",
          modelValue: $setup.physicianName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.physicianName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "physician_name",
          class: "invalid-input-alert mx-1 mt-1"
        })
      ]),
      _createElementVNode("button", {
        type: "submit",
        disabled: false,
        class: _normalizeClass(["result-btn w-100 fs-4", { disabled: !$setup.isFormFilled }])
      }, _toDisplayString(_ctx.$t("Submit")), 3)
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema"]))
}